import { OnboardingForm } from "@nested/onboarding-form";

export const UniversalRender = OnboardingForm;
